import { Button, Chip, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Title, useCommonStyles } from '../../utils';
import { useDispatch } from 'react-redux';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import ErrorHandler from '../../lib/errorHandler';
import { InventoryTypeInum } from '../../lib/enum';
import { getInventoryFields } from '../../Redux/Actions/Inventory';
import CommonAutoComplete from '../Common/CommonAutoComplete';

const InventoryFilter = ({ activeTab, setIsOpenFilterDrawer, isApllyFilter, filterData, setFilterData, initialFilterState, setIsApplyFilter }) => {
    // =============== Hooks ===============
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [subGroupPage, setSubGroupPage] = useState(1);
    const [subGrouptotalCount, setSubGroupTotalCount] = useState();
    const [subGroupList, setSubGroupList] = useState([]);
    const [subGroupOptions, setSubGroupOptions] = useState([])
    const [searchSubGroup, setSearchSubGroup] = useState();

    const [colorPage, setColorPage] = useState(1);
    const [colorTotalCount, setColorTotalCount] = useState();
    const [colorList, setColorList] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [searchColor, setSearchColor] = useState();

    const [micronPage, setMicronPage] = useState(1);
    const [micronTotalCount, setMicronTotalCount] = useState();
    const [micronList, setMicronList] = useState([]);
    const [micronOptions, setMicronOptions] = useState([]);
    const [searchMicron, setSearchMicron] = useState();

    //------------------ Handler ------------------

    const handleChange = (name, value) => {
        if (!value) return;
        const existingList = filterData[`${name}List`] || [];
        const isAlreadyAdded = existingList?.some(item => item?._id === value?._id);
        if (!isAlreadyAdded) {
            const updatedList = [...existingList, value];
            setFilterData({ ...filterData, [`${name}List`]: updatedList });
        } else {
            setSnackBar("error", `This is already selected.`);
        }
    };

    const handleDelete = (name, itemToDelete) => {
        const updatedList = filterData[`${name}List`]?.filter(item => item?._id !== itemToDelete?._id);
        setFilterData({ ...filterData, [`${name}List`]: updatedList });
    };

    //------------------ Sub Group API ------------------
    const _getSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p ? p : subGroupPage,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        { (subGroupList?.length !== subGrouptotalCount) && setSubGroupPage(subGroupPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText ? searchText : "");
            setSubGroupTotalCount(response?.payload?.data?.count)
            if (response?.payload?.data) {
                setSubGroupList([...subGroupList, ...response?.payload?.data?.response])
            }
        }
    };
    const handleChangeInputForSubGroup = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["SubGroup"],
            "limit": 10,
            "page": p,
            "search": searchText
        }
        response = await dispatch(getInventoryFields(body));
        setSubGroupPage(2)
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchSubGroup(searchText);
            setSubGroupList(response?.payload?.data?.response)
        }
    };

    //------------------  Color API ------------------
    const _getColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p ? p : colorPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (colorList?.length !== colorTotalCount) && setColorPage(colorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText ? searchText : "");
            setColorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setColorList([...colorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForColor = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Color"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setColorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchColor(searchText);
            setColorList(response?.payload?.data?.response);
        }
    };

    //------------------  Micron API ------------------
    const _getMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p ? p : micronPage,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        { (micronList?.length !== micronTotalCount) && setMicronPage(micronPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText ? searchText : "");
            setMicronTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setMicronList([...micronList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForMicron = async (p, searchText) => {
        let response;
        let body = {
            "inventoryFieldType": InventoryTypeInum["Micron"],
            "limit": 10,
            "page": p,
            "search": searchText
        };
        response = await dispatch(getInventoryFields(body));
        setMicronPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchMicron(searchText);
            setMicronList(response?.payload?.data?.response);
        }
    };
    // =============== Use Effects ===============
    useEffect(() => {
        _getSubGroup();
        _getColor();
        _getMicron();
    }, [])
    useEffect(() => {
        setSubGroupOptions(subGroupList?.map((e) => e));
    }, [subGroupList]);

    useEffect(() => {
        setColorOptions(colorList?.map((e) => e));
    }, [colorList]);

    useEffect(() => {
        setMicronOptions(micronList?.map((e) => e));
    }, [micronList]);
    return (
        <Grid container spacing={2} p={2}>
            {activeTab?.value == 1 &&
                <>
                    <Grid item xs={12}>
                        <Title>GSM</Title>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            placeholder="Select GSM"
                            options={subGroupOptions || []}
                            getOptionLabel={(option) => option?.subGroup || ""}
                            value={filterData?.subGroup || null}
                            onChange={(e, newValue) => handleChange("subGroup", newValue)}
                            loadData={(subGroupOptions?.length !== subGrouptotalCount) ? _getSubGroup : undefined}
                            handleSearch={(e) => handleChangeInputForSubGroup(1, e?.target?.value)}
                            blurOnSelect={true}
                            searchValue={searchSubGroup}
                        />
                    </Grid>
                    {filterData?.subGroupList?.length > 0 &&
                        <Grid item xs={12} display={'flex'} gap={1}>
                            {filterData?.subGroupList?.map((item) => (
                                <Chip
                                    key={item?.id}
                                    variant="outlined"
                                    sx={{ fontSize: "12px" }}
                                    label={item?.subGroup === "Other" ? item?.otherName : item?.subGroup}
                                    onDelete={() => handleDelete("subGroup", item)}
                                />
                            ))}
                        </Grid>
                    }
                </>
            }
            {(activeTab?.value == 1 || activeTab?.value == 2) &&
                <>
                    <Grid item xs={12}>
                        <Title>Color</Title>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            placeholder="Select Color"
                            options={colorOptions || []}
                            getOptionLabel={(option) => option?.color || ""}
                            value={filterData?.color || null}
                            onChange={(e, newValue) => handleChange("color", newValue)}
                            loadData={(colorOptions?.length !== colorTotalCount) ? _getColor : undefined}
                            handleSearch={(e) => handleChangeInputForColor(1, e?.target?.value)}
                            blurOnSelect={true}
                            searchValue={searchColor}
                        />
                    </Grid>
                    {filterData?.colorList?.length > 0 &&
                        <Grid item xs={12} display={'flex'} gap={1}>
                            {filterData?.colorList?.map((item) => (
                                <Chip
                                    key={item?.id}
                                    variant="outlined"
                                    sx={{ fontSize: "12px" }}
                                    label={item?.color === "Other" ? item?.otherName : item?.color}
                                    onDelete={() => handleDelete("color", item)}
                                />
                            ))}
                        </Grid>
                    }
                </>
            }
            {activeTab?.value == 2 &&
                <>

                    <Grid item xs={12}>
                        <Title>Micron</Title>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CommonAutoComplete
                            placeholder="Select Micron"
                            options={micronOptions || []}
                            getOptionLabel={(option) => option?.micron || ""}
                            value={filterData?.micron || null}
                            onChange={(e, newValue) => handleChange("micron", newValue)}
                            loadData={(micronOptions?.length !== micronTotalCount) ? _getMicron : undefined}
                            handleSearch={(e) => handleChangeInputForMicron(1, e?.target?.value)}
                            blurOnSelect={true}
                            searchValue={searchMicron}
                        />
                    </Grid>
                    {filterData?.micronList?.length > 0 &&
                        <Grid item xs={12} display={'flex'} gap={1}>
                            {filterData?.micronList?.map((item) => (
                                <Chip
                                    key={item?.id}
                                    variant="outlined"
                                    sx={{ fontSize: "12px" }}
                                    label={item?.micron === "Other" ? item?.otherName : item?.micron}
                                    onDelete={() => handleDelete("micron", item)}
                                />
                            ))}
                        </Grid>
                    }
                </>
            }
            <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                <Button className={classes.cancelButton} onClick={() => { setFilterData(initialFilterState) }}>
                    Reset Filter
                </Button>
                <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                    Apply Filter
                </Button>
            </Grid>
        </Grid>
    )
}

export default InventoryFilter